import { memo } from 'react';
import type { MiniAppCatalogRow } from '@/api/client';
import { Badge } from '@/components/ui/Badge/Badge';
import './MiniAppShowcaseCard.css';

export interface MiniAppShowcaseCardProps {
  app: MiniAppCatalogRow;
  onOpenApp: (id: string) => void;
  onToggleLike: (id: string) => void;
  likeBusy: boolean;
}

function MiniAppShowcaseCardInner({ app, onOpenApp, onToggleLike, likeBusy }: MiniAppShowcaseCardProps) {
  const typeLabel = app.type === 'game' ? 'Игра' : 'Утилита';
  const typeBadgeVariant = app.type === 'game' ? 'author' : 'reader';

  return (
    <article className="mini-app-showcase-card">
      <div className="mini-app-showcase-card__inner">
        <button
          type="button"
          className="mini-app-showcase-card__open-hit"
          aria-label={`Открыть «${app.name}»`}
          onClick={() => onOpenApp(app.id)}
        />
        <div className="mini-app-showcase-card__thumb-col" aria-hidden>
          <img
            className="mini-app-showcase-card__thumb-img"
            src={app.preview_link}
            alt=""
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="mini-app-showcase-card__body-col">
          <h3 className="mini-app-showcase-card__title-line">
            <span className="mini-app-showcase-card__title">{app.name}</span>
            <Badge variant={typeBadgeVariant}>{typeLabel}</Badge>
          </h3>
          <p className="mini-app-showcase-card__desc">{app.description}</p>
        </div>
        <button
          type="button"
          className={`mini-app-showcase-card__like ${app.liked_by_me ? 'mini-app-showcase-card__like_active' : ''}`}
          aria-pressed={app.liked_by_me}
          aria-label={app.liked_by_me ? 'Убрать лайк' : 'Поставить лайк'}
          aria-busy={likeBusy}
          onClick={(e) => {
            e.stopPropagation();
            onToggleLike(app.id);
          }}
        >
          <i
            className={`mini-app-showcase-card__like-icon ${app.liked_by_me ? 'fa-solid fa-heart' : 'fa-regular fa-heart'}`}
            aria-hidden
          />
          <span className="mini-app-showcase-card__like-count">{app.likes_count}</span>
        </button>
      </div>
    </article>
  );
}

export const MiniAppShowcaseCard = memo(MiniAppShowcaseCardInner, (prev, next) => {
  return (
    prev.app === next.app &&
    prev.likeBusy === next.likeBusy &&
    prev.onOpenApp === next.onOpenApp &&
    prev.onToggleLike === next.onToggleLike
  );
});
